import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import {matchingDefaultContent} from './matchingSectionDefaultContent';
import {componentsHelper} from "../../helpers/componentsHelper";
import l10n from "../../../lang/locallang";

const matchingSection = (param, is_public = false) => {
    componentsHelper.updateLocalization(matchingDefaultContent);
    const { matchingTexts } = l10n;
    const { enterQuestion, enterText, addNewItem, submit } = l10n.editor;
    param.class = param.class ? param.class : 'editor-section editor-matching-activity';
    param.content = param.content ? param.content : ``;
    param.style = param.style ? param.style : '';
    param.layout = param.layout ? param.layout : '';
    param.section = 'matchingSection';
    let question = param.content.question ? param.content.question : enterQuestion;
    let defaultList = {
        '1': {
            'id': 1,
            'question': matchingTexts[1].question,
            'matching': matchingTexts[1].matching,
        },
        '2': {
            'id': 2,
            'question': matchingTexts[2].question,
            'matching': matchingTexts[2].matching,
        }
    }
    let list = param.content.list ? param.content.list : defaultList;
// for public view should be shaffled matching items
    if(is_public){
        list = componentsHelper.shuffleQuestionsAndMatchings(list);
       // console.log(list)
    }
    let listHtml = `<div class="matching-activity">
                <div class="matching-activity-question">
                    <span ${!is_public ? `contenteditable="true" onpaste="contentEditableFix(event)"` : ''}>${question}</span>
                </div>
                <div class="quiz-matching-result"></div>
                <div class="quiz-matching not-submitted">
                    <div class="matching-result">
                        <ul>`;
    for (let key in list) {
        listHtml += `
            <li data-matching-id="${list[key].id}" class="matching-result_item"><span></span></li>
        `;
    }
    listHtml += `</ul>
                </div>
                <div class="matching-questions">
                <ul>`;
    for (let key in list) {
        listHtml += `
            <li data-matching-id="${list[key].id}" class="matching-questions_item matching-item" draggable="true">
                <span ${!is_public ? `contenteditable="true" onpaste="contentEditableFix(event)" placeholder="${enterText}"` : ''}>${list[key].question}</span>
            </li>
        `;
    }
    listHtml += `
            </ul>
        </div>
        <div class="matching-answers">
            <ul>`;

    for (let key in list) {
        listHtml += `
            <li data-matching-id="${list[key].id}" class="matching-answers_item matching-item">
                <span ${!is_public ? `contenteditable="true" onpaste="contentEditableFix(event)" placeholder="${enterText}"` : ''}>${list[key].matching}</span>
                ${!is_public ? `
                    <button class="btn-delete-matching"><i class="icon icon-close-small"></i></button>
                ` : ''}
            </li>
        `;
    }
    listHtml += `
            </ul>
        </div>
    </div>

    ${!is_public ? `
        <div class="add-e-element-btn-wr">
            <button class="btn add-e-element-btn btn-add-matching"><i class="icon icon-add"></i><span>${addNewItem}</span></button>
        </div>
    ` : `
        <div class="add-e-element-btn-wr">
            <button class="btn btn-orange lesson-submit-quiz" data-quiz="matching">${submit}</button>
        </div>
    `}
    </div>`;


    param.component = listHtml;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {matchingSection};
